import React from "react";
import "./ServiceBody.css";
import { offeredService, faqs } from "./serviceData";
import { useNavigate } from "react-router-dom";
import Timer from "./Timer/Timer";
import { TracingBeam } from "../../../Components/ui/Tracingbeam.tsx";

const RegisterCourse = ({ service_steps }) => {
  const navigate = useNavigate();

  if (!service_steps) return <div>Service data not found</div>;

  return (
    <>
      {/* Service Steps Section */}
      <section className="service-steps">
        <TracingBeam>
          {service_steps.data.map((step, i) => (
            <div
              key={i}
              className={`service-steps ${i % 2 === 0 ? "even" : "reverse"}`}
            >
              <div className="step-img-container">
                <img src={step.img} alt={step.title} />
              </div>
              <div className="step-info">
                <h2 style={{ color: step.color }}>{step.title}</h2>
                <ul>
                  {step.points.map((point, index) => (
                    <li key={index} style={{ color: step.color }}>
                      <span
                        className="step-arrow"
                        style={{ color: step.color }}
                      >
                        &rarr;
                      </span>{" "}
                      {point}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </TracingBeam>
      </section>

      {/* Offers Section */}
      <section className="offers-section">
        <button
          className="enroll-section"
          onClick={() => {
            navigate("/RegisterCourse", { state: service_steps });
            window.scroll(0, 0);
          }}
        >
          <h2>Learn to Develop Great Websites</h2>
        </button>
        <div className="promoted-offers">
          {offeredService.map((off, index) => (
            <div className="offer-card" key={index}>
              <img src={off.img} alt="" />
              <h4>{off.title}</h4>
              <p>{off.para}</p>
            </div>
          ))}
        </div>
      </section>

      {/* FAQ Section */}
      <section className="faq-section">
        <h2>Frequently Asked Questions</h2>
        {faqs.map((faq, index) => (
          <details className="details-container" key={index}>
            <summary>{faq.ques}</summary>
            <p>{faq.ans}</p>
          </details>
        ))}
      </section>

      {/* Timer & Registration Section */}
      <section className="offer-timer-section">
        <div className="time">
          <Timer />
        </div>

        <button
          className="enroll-section enroll-btn"
          style={{ margin: "3rem 0" }}
          onClick={() => {
            navigate("/RegisterCourse", { state: service_steps });
            window.scroll(0, 0);
          }}
        >
          <h2>Register Now</h2>
        </button>
        <p className="offer-notice-text">
          Once the timer hits zero, pricing will be increased to 899.00/-
        </p>
      </section>
    </>
  );
};

export default RegisterCourse;
